import { useAuth } from '../auth/AuthProvider'

/**
 * Returns the list of granted permission codenames for the current user.
 */
export function usePermissions(): string[] {
  const { user } = useAuth()
  return user?.permissions ?? []
}

/**
 * Returns true if the current user has the given permission codename.
 * Admin users always return true.
 */
export function useHasPermission(codename: string): boolean {
  const { user } = useAuth()
  if (!user) return false

  // Admin always has all permissions
  const roleName = typeof user.role === 'string' ? user.role : user.role?.name
  if (roleName === 'admin') return true

  return user.permissions?.includes(codename) ?? false
}
